"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Noop implementation of TwingLoaderInterface.
 *
 * @author Eric MORAND <eric.morand@gmail.com>
 */
class TwingLoaderNull {
    exists(name, from) {
        return false;
    }
    getCacheKey(name, from) {
        return null;
    }
    getSourceContext(name, from) {
        return null;
    }
    isFresh(name, time, from) {
        return true;
    }
    resolve(name, from) {
        return null;
    }
}
exports.TwingLoaderNull = TwingLoaderNull;
